import { render, staticRenderFns } from "./TransferSyllables.vue?vue&type=template&id=13e8d998&lang=pug&"
import script from "./TransferSyllables.vue?vue&type=script&lang=js&"
export * from "./TransferSyllables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports